var AddressModule = /** @class */ (function () {
    function AddressModule() {
    }
    return AddressModule;
}());
export { AddressModule };
